module.exports = __webpack_public_path__ + "img/hotelFamily-4.746b5c84.jpg";